import CandidateRecordPage from "./CandidateRecordPage";

export default CandidateRecordPage;
